let {
  zoomToBounds
} = L.MarkerCluster.prototype;

L.MarkerCluster.include({

  zoomToBounds: function (fitBoundsOptions) {
    if (this._group.options.zoomToMaxBoundsOnClick) {
      let map = this._group._map;
      let boundsZoom = map.getBoundsZoom(this._bounds);
      let zoom = this._zoom + 1;
      if (boundsZoom > zoom) {
        map.setView(this._latlng, boundsZoom);
      }
    } else {
      zoomToBounds.call(this, fitBoundsOptions)
    }
  },

})



// WEBPACK FOOTER //
// ./src/polyfill/MarkerCluster.js